import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/siteData';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Dynamic%20esports%20competition%20stage%20with%20warm%20golden%20orange%20ambient%20lighting%2C%20abstract%20geometric%20patterns%2C%20trophy%20and%20crown%20silhouettes%2C%20dramatic%20spotlights%20from%20above%2C%20modern%20digital%20arena%20atmosphere%2C%20clean%20dark%20gradient%20background%2C%20professional%20competitive%20gaming%20environment%2C%20warm%20golden%20accents&width=1800&height=900&seq=hero-bg-main&orientation=landscape')`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/60 via-foreground-950/40 to-foreground-950/70"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 backdrop-blur-sm border border-primary-400/30 mb-6">
          <i className="ri-fire-line text-primary-400 text-sm"></i>
          <span className="text-primary-300 text-xs font-medium">每日竞技 · 赢取豪礼</span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-5">
          {siteConfig.name}
          <br />
          <span className="text-primary-400">{siteConfig.tagline}</span>
        </h1>

        <p className="text-base md:text-lg text-foreground-200 max-w-2xl mx-auto mb-8 leading-relaxed">
          {siteConfig.description}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/guide"
            className="px-8 py-3.5 rounded-full bg-primary-500 text-white font-semibold text-base whitespace-nowrap hover:bg-primary-600 transition-all duration-200 no-underline cursor-pointer w-full sm:w-auto text-center"
          >
            立即参赛
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/category/rules"
            className="px-8 py-3.5 rounded-full bg-white/15 backdrop-blur-sm text-white font-medium text-base whitespace-nowrap hover:bg-white/25 transition-all duration-200 no-underline cursor-pointer w-full sm:w-auto text-center border border-white/20"
          >
            了解赛制
          </Link>
        </div>

        <div className="mt-10 flex items-center justify-center gap-8 md:gap-12">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-white">500万+</div>
            <div className="text-xs md:text-sm text-foreground-300 mt-1">注册玩家</div>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-primary-400">10万+</div>
            <div className="text-xs md:text-sm text-foreground-300 mt-1">日均参赛</div>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-white">5000万+</div>
            <div className="text-xs md:text-sm text-foreground-300 mt-1">累计奖金</div>
          </div>
        </div>
      </div>
    </section>
  );
}